/**
 * Get slug that matches name of selection
 */
export const getSlug = (name, items) => {
  const found = items.filter((item) => item.name === name)

  if (found.length !== 0) {
    return found[0].slug
  }

  return items[0].slug
}

/**
 * Maps selected values to query.
 * Accepts new seletion data + masterlist of filters.
 */
export const mapSelectionsToQuery = (data, filters) => {
  const { location, eventType, guests } = data

  const query = [
    {
      filter: 'event_location',
      values: [getSlug(location, filters.locations)],
    },
    {
      filter: 'event_category',
      values: [getSlug(eventType, filters.categories)],
    },
    {
      filter: 'event_capacity',
      values: [getSlug(guests, filters.capacities)],
    },
  ]

  return query
}

/**
 * Filter features which are not supported by current active types.
 */
export const filterEligibleFeatures = (features, types) => {
  if (types.length === 0) return features

  if (types.includes('all')) return features

  const eligibleFeatures = []

  /**
   * Loop features & check if they belong to current actives.
   */
  features.forEach((feature) => {
    feature.belongs_to.forEach(({ slug }) => {
      if (types.includes(slug)) {
        if (!eligibleFeatures.includes(feature)) {
          eligibleFeatures.push(feature)
        }
      }
    })
  })

  return eligibleFeatures
}

const findFeatureBySlug = (slug, features) =>
  features.filter((feature) => feature.slug === slug)[0]

/**
 * List active features that are incompatible with types.
 */
export const getIncompatibleActives = (
  activeFeatures,
  features,
  activeTypes,
) => {
  if (activeTypes.length === 0 || activeTypes[0] === 'all') return []

  const incompatibles = []

  activeFeatures.forEach((featureSlug) => {
    const feature = findFeatureBySlug(featureSlug, features)
    let isCompatibleWithSome = false

    /**
     * We need to keep feature eligible,
     * if even one active type matches.
     *
     * Start with negative assumption,
     * work towards positive.
     */
    feature.belongs_to.forEach(({ slug }) => {
      if (activeTypes.includes(slug)) {
        isCompatibleWithSome = true
      }
    })

    if (!isCompatibleWithSome) {
      incompatibles.push(feature)
    }
  })

  return incompatibles
}

export default {
  getSlug,
  mapSelectionsToQuery,
  filterEligibleFeatures,
  getIncompatibleActives,
}
